/**
 * Responsáel pela camada de rota planejada
 * Created by adalto on 5/13/14.
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.LayerEvent = (function () {

    function LayerEvent (layeName, routeId) {

        Greenmile.Toolbar.MapLayerActions.Base.apply(this, arguments);

        this.LAYER_NAME = layeName;
        this.RESOURCE_LAYER = 'ToolBar.Layers.LayerEvent';

        let instanceToDataClass = null;

        this.setInstanceToClassData = instance => (instanceToDataClass = instance);

        this.afterClickOnCheckBox = function (context) {
            return function () {
                var _element = this;
                context.setLayerStatusOnLocalStorageByTagName(_element.checked);
                if (_element.checked) {
                    if (instanceToDataClass) {
                        instanceToDataClass.requestEventsAndAddOnMap();
                    }
                } else {
                    if (instanceToDataClass) {
                        instanceToDataClass.cleanMarkerEvent();
                    }
                }
            };
        }(this);

        this.render = () => {

            const itemList = document.createElement('li');
            const divLabel = document.createElement('div');
            const divCheckBox = document.createElement('div');
            const label = document.createElement('label');
            this.checkBox = document.createElement('input');
            const layerIsChecked = this.getLayerStatusOnLocalStorage();

            const checkboxId = this.routeId ? this.LAYER_NAME + '_' + this.routeId : this.LAYER_NAME;
            this.checkBox.id = checkboxId;
            this.checkBox.name = this.LAYER_NAME;
            this.checkBox.type = 'checkbox';
            this.checkBox.removeEventListener('click', this.afterClickOnCheckBox);
            this.checkBox.addEventListener('click', this.afterClickOnCheckBox);

            divCheckBox.className = 'radio';
            divCheckBox.appendChild(this.checkBox);

            label.setAttribute('for', checkboxId);
            label.innerHTML = Monet.I18n.getResourcesByKey(this.RESOURCE_LAYER);

            divLabel.className = 'text';
            divLabel.appendChild(label);

            itemList.appendChild(divCheckBox);
            itemList.appendChild(divLabel);

            if (layerIsChecked) {
                this.checkBox.checked = 'checked';
            }

            const addButton = document.createElement('input');
            const action = () => {
              const filterModal = new Greenmile.EventLog.FilterModal(routeId);
              filterModal.show();
            };

            addButton.type = 'button';
            addButton.className = 'event_route';
            addButton.removeEventListener('click', action);
            addButton.addEventListener('click', action);
            itemList.appendChild(addButton);

            return itemList;

        };

    }

    return LayerEvent;

})();
